<template>
	<!-- 创建书单-->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p v-if="listId != ''" class="header_titile">编辑书单</p>
					<p v-else class="header_titile">创建书单</p>
				</div>
			</div>
		</van-sticky>
		<div class="setBoxInfo">
			<div class="zlset">
				<span>书单名称：</span>
				<input type="text" v-model="bookshelf_name" placeholder="书单名称" />
			</div>
			<div class="queryQingjiaBox">
				<div class="qjReasonBox">
					<div class="newstyle">
						<span class="qjReasonTxt">书单简介：</span>
						<span class="xianzhi"><span style="color: #ff4081;">{{remnant}}</span>/200</span>
					</div>
					<div class="textareaBox">
						<!-- <textarea class="site"
								  maxlength="200" 
								  @input="descInput" 
								  v-model="desc" 
								  placeholder="请输入书单简介"
						></textarea> -->
						<editor-bar v-model="desc"  :isClear="isClear" @change="change"></editor-bar>
					</div>
				</div>
				<div class="queryQingjiaBox" v-if="listId == ''">
					<div class="qjReasonBox">
						<div class="newstyle">
							<span class="qjReasonTxt">添加作品：</span>
							<span class="xianzhi"><span style="color: #ff4081;">{{remnant1}}</span>/200</span>
						</div>
						<div class="textareaBox textareaBox_two">
							<!-- <textarea class="site" 
									  maxlength="200" 
									  @input="descInput1" 
									  v-model="desc1" 
									  placeholder="添加作品评论"
							></textarea> -->
							<editor-bar v-model="desc1"  :isClear="isClear01" @change="change01"></editor-bar>
							<img v-if="book_img==undefined||book_img==''" @click='selectBook' src="../../assets/img/cjsd_upimg.png" alt=""
							 class="cjsd_upimg">
							<img else :src="$api.$BASE_URL_img+this.book_img" alt="" class="cjsd_upimg" @click='selectBook'>

						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bcicon_img">
			<img src="../../assets/img/flower.png" alt="" class='flower'>
			<button @click="addShelf">保存</button>
		</div>
	</div>
</template>

<script>
	import EditorBar from '../../components/wangEnduit.vue'
	import {
		Toast
	} from 'vant';
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				desc: '', //文本域内容
				remnant: 0, //开始字数
				desc1: '', //文本域内容
				remnant1: 0, //开始字数
				book_id: '',
				bookshelf_name: '',
				book_img: '',
				bookshelfPage:'',
				listId: '',
				isClear: false,
				isClear01: false,
			}
		},
		created() {
			this.book_id = this.$route.query.book_id;
			this.book_img = this.$route.query.book_img;
			this.desc = this.$route.query.content;
			this.bookshelf_name = this.$route.query.name;
			this.desc1 = this.$route.query.comment;
			console.log(this.book_img);
			
			this.bookshelfPage = this.$route.query.bookshelfPage;
			
			var _t = this;
			if(_t.$route.query.listId){
				_t.listId = _t.$route.query.listId;
				// if(!_t.$route.query.book_id){
					_t.editDetail();
				// }else{
				// 	_t.remnant = _t.desc.length;
				// 	_t.remnant1 = _t.desc1.length;
				// }
				
			}
			if(_t.$route.query.book_id){
				_t.remnant = _t.desc.length;
				_t.remnant1 = _t.desc1.length;
			}
		},
		methods: {
			change(val) {
				this.desc = val;
				var valTxt=val.replace(/['&',<br>,'bsp',';','</p>','<p>','</','n']|(&nbsp;)|\s/gi, '');
				this.remnant = valTxt.length;
				var reg = /<\/?.+?\/?>/g;
				var t_content = val.replace(reg,'');
				// if(t_content){
				// 	this.is_content = false;
				// }else{
				// 	this.is_content = true;
				// }
			},
			change01(val){
				this.desc1 = val;
				var valTxt=val.replace(/['&',<br>,'bsp',';','</p>','<p>','</','n']|(&nbsp;)|\s/gi, '');
				this.remnant1 = valTxt.length;
				var reg = /<\/?.+?\/?>/g;
				var t_content = val.replace(reg,'');
			},
			// 文本域字数限制
			descInput() {
				let txtVal = this.desc.length;
				this.remnant = 0 + txtVal;
			},
			descInput1() {
				let txtVal = this.desc1.length;
				this.remnant1 = 0 + txtVal;
			},
			back() {
				
				if(this.$route.query.bookshelfPage == 'bookshelfPageUrl'){
					this.$router.push({path: '/bookshelf',query:{com_name: 'chunai'}})
				}else if(this.$route.query.editBookLis == 'cjsdEdit'){
					this.$router.push({path: '/bookdyinfo',query:{listId: this.$route.query.listId}})
				}else{
					this.$router.push({path: '/bookshelf',query:{com_name: 'chunai'}})
				}
			},
			get_add_books_list() {
				if (this.book_id == undefined || this.bookshelf_name == undefined || this.desc == undefined) {
					Toast('请输入书单内容');
				} else {
					this.$axios.post(
						`${this.$api.add_books_list}?books_id=${this.book_id}&name=${this.bookshelf_name}&content=${this.desc}&comment=${this.desc1}&list_id=${this.listId}`
					).then(res => {
						Toast(res.data.msg);
						if(res.data.code == 1){
							this.$router.push({path: '/bookshelf'})
						}
						if(this.$route.query.editBookLis == 'cjsdEdit'){
							this.$router.push({path: '/bookdyinfo',query:{listId: this.$route.query.listId}})
						}else{
							this.$router.push({path: '/bookshelf',query:{com_name: 'chunai'}})
						}
						
					})
				}

			},
			//添加书单
			addShelf() {
				this.get_add_books_list()
				
			},
			// 选书
			selectBook() {
				if (this.bookshelf_name == undefined && this.desc == undefined) {
					Toast('请输入书单内容');
					return false;
				}else {
					this.$router.push({
						path: '/searchPage',
						query: {
							madeName: this.bookshelf_name,
							madeNontent: this.desc,
							madeComment:this.desc1,
							madeListId: this.listId,
						}
					
					})
				}
			},
			editDetail() { //编辑 书单详情
				var _t = this;
				_t.$axios.post(`${_t.$api.books_list_detail}?collect_id=${_t.listId}`).then(res => {
					if(res.data.code == 1){
						var resdata = res.data.data;
						_t.bookshelf_name = resdata.name;
						_t.desc = resdata.describe;
						_t.remnant = resdata.describe.length;
						if(resdata.book_list.length != 0){
							_t.book_id = resdata.book_list[0].id;
							_t.desc1 = resdata.book_list[0].comment;
							_t.book_img = resdata.book_list[0].cover_image;
							_t.remnant1 = resdata.book_list[0].comment.length;
						}
						
					}else{
						_t.$toast(res.data.msg);
					}
				})
			}

		}
	}
</script>
<style lang="less" scoped>
	.van-dialog__confirm, .van-dialog__confirm:active {
		color: #ff4081;
	}
	/deep/.w-e-toolbar{
		display: none;
	}
	/deep/.w-e-text{
		padding: 0 !important;
	}
	/deep/.qjylBox .setBoxInfo .queryQingjiaBox .qjReasonBox .textareaBox .w-e-text{
		padding: 0 !important;
	}
	/deep/.text{
		height: 320px;
	}
	.qjylBox {
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		position: relative;
		color: #000;
		.bcicon_img {
			text-align: center;
			position: fixed;
			bottom: 5%;
			left: 0;
			width: 100vw;

			.flower {
				position: absolute;
				top: -60px;
				left: 20%;
				width: 100px;
			}

			button {
				border: 0;
				line-height: 80px;
				font-size: 32px;
				/*px*/
				width: 90%;
				background-color: #FF4081;
				color: #fff;
				border-radius: 10px;
			}
		}

		// 头部
		.headerBox {
			height: 160px;
			// background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc03.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						height: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		.setBoxInfo {
			padding: 20px 16px;
			padding-top: 0;

			.zlset {
				line-height: 60px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				display: flex;
				flex-direction: column;
				margin-top:15px;

				span {
					font-size: 30px;
					/*px*/
					font-weight: bold;
					line-height: 40px;
				}

				input::placeholder,
				input {
					flex: 1;
					padding-right: 10px;
					font-size: 30px !important;
					/*px*/
					font-weight: bold;
				}

			}

			//作品简介
			.queryQingjiaBox {
				padding: 20px 0px;
				background-color: #fff;

				//文本域
				.qjReasonBox {
					position: relative;
					overflow: hidden;
					border-bottom: 1px solid #f0f0f0;
					padding-top: 20px;
					.newstyle {
						width:100%;
						display: flex;
						justify-content: space-between;
						position: absolute;
						top: 10px;
						left: 0;
						
						.xianzhi {
							background-color: #fff;
							font-size: 28px;
							/*px*/
						}
					}
					/*no*/
					.qjReasonTxt {
						line-height: 40px;
						display: block;
						// float: left;
						font-weight: 600;
						font-size: 30px;
						/*px*/
					}

					.textareaBox {
						height: 300px;
						overflow-y: scroll;
						/deep/ .w-e-text{
							padding:0 20px 0 36px;
							
							/deep/  p{
								font-size: 30px;/*px*/
								color: #000;
							}
						}
						// float: right;
						display: block;
						position: relative;
						padding-bottom: 10px;
						margin-top:5px;
						margin-bottom: 30px;
						textarea {
							padding-top: 10px;
							width: calc(100vw - 32px);
							border: 0;
							height: 220px;
							color: #a3a3a3;
						}

						textarea::placeholder {
							font-size: 24px;
							/*px*/
						}


						.cjsd_upimg {
							position: absolute;
							top: 18px;
							right: 0;
							width: 180px;
							height: 260px;
						}
					}

					.textareaBox_two {
						textarea {
							width: 75vw;
						}
					}
				}
			}

		}

	}
</style>
